// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__opC_r","label":"styles_label__2vi4j","icon":"styles_icon__uuYNu"};